import React, {useEffect, useRef} from 'react';
import styled, {CSSObject} from 'styled-components';
import {Image, ImageProps} from '@volkswagen-onehub/components-core';

const StyledImage = styled(Image)<{customStyles?: CSSObject}>`
  margin: 0 auto;
  opacity: 0;

  opacity: 0; /* Set initial opacity to 0 */
  transition: opacity 0.5s ease-in-out; /* Apply the transition */

  &.loaded {
    opacity: 1; /* Set opacity to 1 when the 'loaded' class is added */
  }

  ${(props) => props.customStyles};
`;

type Props = {
  customStyles?: CSSObject;
  isActive?: boolean;
} & ImageProps;

const FadeInImage: React.FC<Props> = ({
  customStyles,
  isActive,
  ...imgProps
}) => {
  const imageRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const img = imageRef.current;

    if (isActive) {
      img?.classList.add('loaded');
    } else {
      img?.classList.remove('loaded');
    }
  }, [isActive]);

  return (
    <StyledImage {...imgProps} ref={imageRef} customStyles={customStyles} />
  );
};

export default FadeInImage;
